// All user related database operations can be defined here.
import moment from 'moment';
import { api } from '..';
import {
  AuthenticatePaymentResponse,
  AuthenticatePrivatePaymentResponse,
  BuyTicketWithPixResponse,
  BuyPrivateTicketWithPixResponse,
  CancelPixResponse,
  CancelPrivatePixResponse,
  OpenPixResponse,
  OpenPrivatePixResponse,
  RegularizeListWithPixResponse,
  RegularizeWithPixResponse,
} from './types';

export * from './types';

export const fetchBuyTicketWithPixService = async (params: {
  driverId: string;
  vehicleId: string;
  stayTime: string;
  price: string;
  paidPrice: string;
  routeId: string;
  paymentMethodId: string;
  driverDocument: string;
}) => {
  const { driverId, ...otherParams } = params;
  return await api
    .post<BuyTicketWithPixResponse>(
      `serviceorders/driver/${driverId}/buyticket/pix`,
      otherParams,
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err.response.data);
    });
};

export const fetchBuyPrivateTicketWithPixService = async (params: {
  driverId: number;
  privateParkingId: string;
  paymentMethodId: number;
  cloudParkTicketId: string;
  cloudParkToken: string;
  cloudParkId: string | null;
  cloudParkContract: string;
  cloudParkEntryDate: string;
  cloudParkPlate: string;
  cloudParkPrice: number;
  driverDocument: string;
}) => {
  const { driverId, ...otherParams } = params;
  const handledEntryDateTime = moment(
    otherParams.cloudParkEntryDate,
    'DD/MM/YYYY HH:mm:ss',
  ).format('YYYY-MM-DD HH:mm:ss');
  const handledParams = {
    ...otherParams,
    cloudParkEntryDate: handledEntryDateTime,
  };
  return await api
    .post<BuyPrivateTicketWithPixResponse>(
      `privateparkings/driver/${driverId}/buyticket/pix`,
      handledParams,
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err.response.data);
    });
};

export const fetchRegularizeWithPixService = async (params: {
  driverId: string;
  irregularityId: string;
  plate: string;
  type: string;
  entryDateTime: string;
  exitDateTime: string;
  stayTime: string;
  price: string;
  routeId: number;
  driverDocument: string;
}) => {
  const { driverId, irregularityId, ...otherParams } = params;
  return await api
    .post<RegularizeWithPixResponse>(
      `notifications/driver/${driverId}/regularize/${irregularityId}/pix`,
      otherParams,
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err.response.data);
    });
};

export const fetchRegularizeListWithPixService = async (params: {
  driverId: string;
  plate: string;
  type: string;
  entryDateTime: string;
  exitDateTime: string;
  stayTime: string;
  price: number;
  routeId: number;
  vehicleId: number | null;
  irregularities: number[];
  observation: string;
  driverDocument: string;
}) => {
  const { driverId, ...otherParams } = params;
  return await api
    .post<RegularizeListWithPixResponse>(
      `notifications/driver/${driverId}/regularizeall/pix`,
      JSON.stringify(otherParams),
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err.response.data);
    });
};

export const fetchOpenPixService = async (params: { driverId: string }) => {
  const { driverId } = params;
  return await api
    .get<OpenPixResponse>(`drivers/${driverId}/openpayment`)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err.response.data);
    });
};

export const fetchAuthenticatePaymentService = async (params: {
  driverId: string;
  serviceOrderId: string;
  vehicleId: string;
}) => {
  const { driverId, serviceOrderId } = params;
  return await api
    .put<AuthenticatePaymentResponse>(
      `serviceorders/driver/${driverId}/authenticatepayment/${serviceOrderId}`,
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const fetchAuthenticatePrivatePaymentService = async (params: {
  driverId: string;
  privateParkingPaymentId: string;
}) => {
  const { driverId, privateParkingPaymentId } = params;
  return await api
    .put<AuthenticatePrivatePaymentResponse>(
      `privateparkings/driver/${driverId}/authenticatepayment/${privateParkingPaymentId}`,
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const fetchCancelPixService = async (params: {
  driverId: string;
  serviceOrderId: string;
}) => {
  const { driverId, serviceOrderId } = params;
  return await api
    .put<CancelPixResponse>(
      `serviceorders/driver/${driverId}/cancel/pix/payment/${serviceOrderId}`,
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err.response.data);
    });
};

export const fetchCancelPrivatePixService = async (params: {
  driverId: string;
  privateParkingPaymentId: string;
}) => {
  const { driverId, privateParkingPaymentId } = params;
  return await api
    .put<CancelPrivatePixResponse>(
      `privateparkings/driver/${driverId}/cancel/pix/payment/${privateParkingPaymentId}`,
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err.response.data);
    });
};
